module.exports = __webpack_public_path__ + "img/Icon-tree-user-profile.039747a6.svg";